export class Login{
  Schema:string;
  UserName:string;
  Password:string;
}
